(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('TypeIbqDeleteController',TypeIbqDeleteController);

    TypeIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'Type'];

    function TypeIbqDeleteController($uibModalInstance, entity, Type) {
        var vm = this;

        vm.type = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Type.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
